import { Application } from "../../common/constants/common";
import { retrieveSessionStorage, saveSessionStorage } from "../../common/storageUtils";

// One reload a minute at most, so a file that is missing for any other reason cannot make the
// tab reload over and over.
const reloadCooldownMs = 60 * 1000;

/**
 * Handles the event Vite raises when a file of the running build cannot be loaded. A deploy
 * removes the previous build's files, so a tab that was opened before the deploy fails when it
 * loads its next screen. Reloading the tab picks up the current build.
 * @param {Event} event the "vite:preloadError" event
 */
export const reloadOnStaleBuild = (event) => {
  const lastReloadAt = Number(retrieveSessionStorage(Application.StorageKeys.StaleBuildReloadAt)) || 0;

  if (Date.now() - lastReloadAt < reloadCooldownMs) {
    return;
  }

  // Stops Vite from throwing the load error: the reload is the answer to it.
  event.preventDefault();
  saveSessionStorage(Application.StorageKeys.StaleBuildReloadAt, Date.now());
  window.location.reload();
};
